import type {
  ComponentValueResponse,
  DeclareExperiencesRequest,
  ProductTypeAssessmentPublic,
  ProductTypesInUseResponse,
  SaveComponentValueResponse,
  StartQuizAttemptRequest,
  StartQuizAttemptResponse,
  SubmitQuestionnaireRequest,
  SubmitQuizAttemptRequest,
  SubmitQuizAttemptResponse,
} from "@repo/shared/types";
import { get, post } from "../_client";

const BASE = "/internal/flow-instances";

export function getFlowInstanceValue(instanceId: string) {
  return get<ComponentValueResponse>(
    `${BASE}/${instanceId}/product-assessment/flow-instance-value`,
  );
}

export function declareExperiences(instanceId: string, request: DeclareExperiencesRequest) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/product-assessment/declare`,
    request satisfies DeclareExperiencesRequest,
  );
}

export function getAssessments(instanceId: string) {
  return get<ProductTypeAssessmentPublic[]>(`${BASE}/${instanceId}/product-assessment/assessments`);
}

export function getProductTypesInUse(instanceId: string) {
  return get<ProductTypesInUseResponse>(
    `${BASE}/${instanceId}/product-assessment/product-types-in-use`,
  );
}

/** QL-505 — `subjectId` addresses one party when several answer (a group member, or a representative when 2+ are registered). */
export function startQuiz(instanceId: string, productTypeId: string, subjectId?: string) {
  return post<StartQuizAttemptResponse>(`${BASE}/${instanceId}/product-assessment/quiz/start`, {
    productTypeId,
    ...(subjectId ? { subjectId } : {}),
  } satisfies StartQuizAttemptRequest);
}

export function submitQuiz(instanceId: string, request: SubmitQuizAttemptRequest) {
  return post<SubmitQuizAttemptResponse>(
    `${BASE}/${instanceId}/product-assessment/quiz/submit`,
    request satisfies SubmitQuizAttemptRequest,
  );
}

export function submitQuestionnaire(instanceId: string, request: SubmitQuestionnaireRequest) {
  return post<SaveComponentValueResponse>(
    `${BASE}/${instanceId}/product-assessment/questionnaire/submit`,
    request satisfies SubmitQuestionnaireRequest,
  );
}
